import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  shared: {
  },
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app isn't
   * built with invalid env vars.
   */
  server: {
    WEB_URL: z.string(),
    // DATABASE_URL: z.string(),
    NEXTAUTH_URL: z.string().min(1, "Next Auth URL is Required"),
    NEXTAUTH_SECRET: z.string().min(1, "Next Auth Secret is Required"),
  },
  /**
   * Specify your client-side environment variables schema here.
   * For them to be exposed to the client, prefix them with `NEXT_PUBLIC_`.
   */
  client: {
    // NEXT_PUBLIC_CLIENTVAR: z.string(),
    NEXT_PUBLIC_WEB_URL: z.string(),
    NEXT_PUBLIC_ENVIRONMENT: z.string().optional(),
    NEXT_PUBLIC_STAGE: z.string().default("dev"),
    NEXT_PUBLIC_REGION: z.string().default("us-east-1"),
    // Cognito variables
    NEXT_PUBLIC_COGNITO_CLIENT_ID: z
      .string()
      .min(1, "Cognito Client ID is Required"),
    NEXT_PUBLIC_COGNITO_USER_POOL_ID: z
      .string()
      .min(1, "Cognito User Pool ID is Required"),
    NEXT_PUBLIC_COGNITO_DOMAIN_NAME: z
      .string()
      .min(1, "Cognito Identity Pool ID is Required"),
    NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN: z.string().default(".localhost"),
    NEXT_PUBLIC_S3_URL: z.string().min(1, "S3 URL is Required"),
    NEXT_PUBLIC_ORDER_SQS: z.string().optional(),
  },
  /**
   * Destructure all variables from `process.env` to make sure they aren't tree-shaken away.
   */
  experimental__runtimeEnv: {
    NEXT_PUBLIC_REGION: process.env.NEXT_PUBLIC_REGION,
    NEXT_PUBLIC_WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
    NEXT_PUBLIC_COGNITO_CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
    NEXT_PUBLIC_COGNITO_USER_POOL_ID:
      process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
    NEXT_PUBLIC_COGNITO_DOMAIN_NAME:
      process.env.NEXT_PUBLIC_COGNITO_DOMAIN_NAME,
    NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN:
      process.env.NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_STAGE: process.env.NEXT_PUBLIC_STAGE,
    NEXT_PUBLIC_S3_URL: process.env.NEXT_PUBLIC_S3_URL,
    NEXT_PUBLIC_ORDER_SQS: process.env.NEXT_PUBLIC_ORDER_SQS,
  },
  skipValidation:
    !!process.env.CI ||
    !!process.env.SKIP_ENV_VALIDATION ||
    process.env.npm_lifecycle_event === "lint",
  isServer: typeof window === "undefined",
});
